import FilterItem from "./FilterItem.vue";
import FiltersMixin from "@/mixins/FiltersMixin.vue";
import SegmentFilterBody from "./bodies/SegmentFilterBody.vue";
import TaggedText from "@/components/tableElements/TaggedText.vue";
import FlexRow from "@/components/FlexRow.vue";
import { truncateString } from "@/utils";
export default {
  name: "SegmentFilter",
  components: {
    FilterItem,
    SegmentFilterBody,
    TaggedText,
    FlexRow
  },
  emits: ["apply", "cleared"],
  expose: ["openDropdown"],
  mixins: [FiltersMixin],
  props: {
    segments: {
      type: Object,
      required: true,
      default: () => ({
        filterState: {
          selected: [],
          list: []
        },
        isModified: false,
        select: () => {},
        deselect: () => {},
        clear: () => {},
        apply: () => {},
        asyncSearch: () => {}
      })
    },
    sellers: {
      type: Object
    }
  },
  computed: {
    getSegmentsSelectedTitle() {
      const joined = this.segments?.filterState?.selected?.map(el => el?.segment).join(", ");
      return joined ? truncateString(joined, 200) : "";
    }
  },
  methods: {
    handleSearch({
      value
    }) {
      // If value is empty, clear the searching state
      if (value.length === 0) {
        this.segments.searching = false;
      }
      this.segments.asyncSearch({
        keyword: value,
        args: {
          seller_id: this.sellers?.filterValues || []
        }
      });
    },
    handleClear() {
      this.segments.clear();
    },
    onDiscard() {
      // Revert the staged pending changes back to the last-applied selection.
      this.segments.clearDraft();
    },
    onHidden() {
      this.segments.clearDraft();
    },
    onRestoreSearch() {
      this.segments.restoreSearch();
    },
    handleSelect({
      id
    }) {
      //console.log('id', id)
      this.segments.select({
        id
      }, 'id');
    },
    handleSelectOnly({
      id
    }) {
      this.segments.selectOnly({
        id
      }, 'id');
    },
    handleDeselect({
      id
    }) {
      this.segments.deselect({
        id
      }, 'id');
    },
    handleClearAll() {
      this.segments.clear();
      this.$emit('cleared');
    },
    openDropdown(initializer = async () => {}, callback = () => {}) {
      this.openAsyncFilterDropdown(this.$refs.segmentFilterItem, initializer, callback);
    }
  }
};